export enum EButtonDirective {
	add,
	secondary,
	success,
	agreement,
	approve,
	reject,
	other,
	proceed
}